module.exports = __webpack_public_path__ + "img/close.d5de24f2.svg";